import { TSingleStatsProps } from './singleStats.type'
import './singleStats.style.scss'
import Line from '../../assets/svg/line.svg'

const SingleStats = ({
  name,
  icon,
  color,
  current,
  increase,
  up,
}: TSingleStatsProps) => {
  return (
    <div className='single_stats' key={name}>
      <div
        className='icon_container'
        style={{
          color,
          fontSize: 22,
        }}
      >
        {icon}
      </div>

      <div className='single_stats_details'>
        <div className='single_stats_title'>
          <p className='name'>
            Total{' '}
            <span
              style={{
                color,
              }}
            >
              {name}
            </span>
          </p>
          <div className='total'>
            {current}
            {increase !== '' && <span>+{increase}</span>}
          </div>
        </div>

        <div
          className='graph'
          style={{
            color,
          }}
        >
          <div
            className='graph_line'
            style={{
              stroke: `${color} !important`,
            }}
          >
            <img src={Line} alt='graph' />
          </div>
          {up !== '' && (
            <div className='percentage'>{up.startsWith('-') ? up : `+${up}`}</div>
          )}
        </div>
      </div>
    </div>
  )
}

export default SingleStats
